<template>
    <ItemCard :item="resource" :imageUrl="imageUrl" bookmarkRoute="tm.bookmark"  :actionUrl="url" @click="notifyAlgoliaAboutClick()">
        <template v-slot:badge >
            <div
                class="overflow-hidden flex-shrink-0 bottom-0 left-0 pr-2  pl-1 -ml-1 -mb-1  absolute bg-white flex items-center justify-center rounded-tr-xl rounded-bl-xl text-sm z-10">
                {{ resource.type }}
            </div>
        </template>

        <template v-slot:image>
            <div class="w-full h-full resource-card duration-150 object-cover overflow-hidden rounded-bl-[13px] rounded-tr-xl rounded-tl-xl rounded-br-xl">
                <img alt="stc" class="w-full h-full object-cover group-hover:scale-105 duration-150  " :src="imageUrl" />
            </div>
        </template>

        <template v-slot:bands>

            <Grades :grades="resource.grades" />
        </template>

        <template v-slot:title>
            <a :href="url">
                <AisHighlight v-if="isLoadedFromAlgolia" attribute="title" :hit="resource" :class-names="{
                    'ais-Highlight': 'font-semibold line-clamp-3',
                }"  />
                <div v-else class="line-clamp-3 mt-[12px] font-semibold">{{ resource.title }}</div>
            </a>
        </template>

        <template v-slot:action v-if="url">
            <PrimaryButton @click="notifyAlgoliaAboutClick()" :href="url">
                <span class="capitalize">View Resource</span>
            </PrimaryButton>
        </template>

        <template v-slot:tags >
            <span v-for="subject in resource.subjects_list_short" :key="subject" class="text-xs rounded-2xl bg-[#EEF1F6] px-2.5 py-0.5">{{ subject }}</span>
        </template>

    </ItemCard>
</template>

<script>
import { inject } from 'vue';
import ItemCard from '../../../components/ItemCard.vue'
import { AisHighlight } from 'vue-instantsearch/vue3/es';
import { usePage } from '@inertiajs/vue3';
import {sortGradeBands} from '../../../Helpers/Utils.js'
import Grades from '../../../components/Grades.vue'
import { trackClick } from '../../../Helpers/MeilisearchAnalytics.js'

export default {
    components: {
        ItemCard,
        AisHighlight,
        Grades
    },
    props: {
        resource: Object,
        isLoadedFromAlgolia: {
            default : true,
            type: Boolean
        },
        position: {
            type: Number,
            default: null
        },
        queryUid: {
            type: String,
            default: null
        },
    },
    computed: {
        url() {
            if (this.resource.slug)
            {
                let url;
                if(this.resource.is_external_resource)
                {
                    url = route('resources.show', this.resource.slug);
                }
                else if(this.resource.is_internal_resource)
                {
                    url = route('stc.show', this.resource.slug);
                }
                else if(this.resource.is_internal_unit_plan)
                {
                    url = route('stc.unit', this.resource.slug);
                }

                // Add queryUid to URL for conversion tracking
                if (url && this.queryUid) {
                    const separator = url.includes('?') ? '&' : '?';
                    return url + separator + 'queryUid=' + encodeURIComponent(this.queryUid);
                }
                return url;
            }
            return null;
        },
        providerImageUrl() {
            return this.resource.firstProviderCircleImageUrl ?? this.resource.firstProviderImageUrl;
        },
        imageUrl() {
            if(this.resource.image_conversions && this.resource.image_conversions['240'])
                return this.resource.image_conversions['240'];

            if(this.resource.image_conversions && this.resource.image_conversions['360']) {
                return this.resource.image_conversions['360'];
            }
            return this.resource.image;
        }
    },
    methods:{
        notifyAlgoliaAboutClick() {
            // Track click event for Meilisearch analytics
            const indexUid = this.teachingMaterialsIndex || 'teaching_materials';
            trackClick({
                indexUid: indexUid,
                objectId: String(this.resource.id),
                objectName: this.resource.title,
                position: this.position,
                queryUid: this.queryUid
            });

            // Legacy Algolia tracking (if still needed)
            if (this.aa) {
                let resourceId = this.resource.id;
                this.aa('clickedObjectIDs', {
                    objectIDs: [resourceId.toString()],
                    eventName: 'External Resource Clicked',
                    index: this.teachingMaterialsIndex
                });
            }
        },
        sortGradeBands
    },
    setup() {
        const aa = inject('initAndGetAlgoliaEventDispatcher')()
        const page = usePage();
        const teachingMaterialsIndex = page.props.integrations?.meilisearch?.teachingMaterialsIndex ||
                                      page.props.integrations?.algolia?.teachingMaterialsIndex ||
                                      'teaching_materials';
        return {
            aa,
            teachingMaterialsIndex
        }
    }
}
</script>
